<template>
  <input ref="datepick" class="form-control" type="text" :value="value" />
</template>

<script>
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import { English } from 'flatpickr/dist/l10n/default.js'

export default {
  name: 'CalendarDate',
  props: {
    value: {
      type: String
    },
    minDate: {
      type: String
    },
    maxDate: {
      type: String
    },
    disable: {
      type: Array,
      default: () => []
    },
    allowInput: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    calendar: null
  }),
  computed: {
    localeRU() {
      return this.$i18n.locale === 'ru'
    }
  },
  watch: {
    value() {
      this.calendar.setDate(this.value)
    },
    minDate: 'updateCalendar',
    maxDate: 'updateCalendar',
    disable: 'updateCalendar',
    localeRU() {
      // При изменении локали пересоздаем календарь
      this.reinitCalendar()
    }
  },
  mounted() {
    this.initCalendar()
  },
  beforeDestroy() {
    this.calendar.destroy()
  },
  methods: {
    initCalendar() {
      if (!this.$refs.datepick) {
        return
      }
      const format = this.localeRU ? 'd.m.Y' : 'm/d/Y'
      flatpickr.localize(this.localeRU ? Russian : English)
      this.calendar = flatpickr(this.$refs.datepick, {
        altInput: true,
        altFormat: format,
        allowInput: this.allowInput,
        defaultDate: this.value,
        minDate: this.minDate ? this.minDate : null,
        maxDate: this.maxDate ? this.maxDate : null,
        disable: this.disable,
        onChange: (_, dateStr) => this.$emit('input', dateStr)
      })
      if (this.allowInput) {
        this.calendar.altInput.addEventListener('keyup', event => {
          const value = event.target.value
          if (/^\d$/.test(event.key) && value.length < 10) {
            if (value.length === 2 && value[2] !== '.') {
              event.target.value = value + '.'
            } else if (value.length === 5 && value[5] !== '.') {
              event.target.value = value + '.'
            }
          }
        })
        this.calendar.altInput.addEventListener('change', event => {
          let parseDate = flatpickr.parseDate(event.target.value, format)
          this.calendar.setDate(parseDate)
          this.$emit('input', flatpickr.formatDate(parseDate, 'Y-m-d'))
        })
      }
    },
    reinitCalendar() {
      this.destroyCalendar()
      this.initCalendar()
    },
    destroyCalendar() {
      if (this.calendar) {
        this.calendar.destroy()
        this.calendar = null
      }
    },
    updateCalendar() {
      if (this.calendar) {
        if (this.minDate) {
          this.calendar.set('minDate', this.minDate)
        }
        if (this.maxDate) {
          this.calendar.set('maxDate', this.maxDate)
        }
        if (this.disable) {
          this.calendar.set('disable', this.disable)
        }
      }
    }
  }
}
</script>
